export default __webpack_public_path__ + "static/media/rest-api.17ff191b.svg";